// Layout.js

import React from 'react';
import IdleTimeoutRedirect from './IdleTimeoutRedirect';

const Layout = ({ children }) => {
    return (
        <div>
            <IdleTimeoutRedirect />
            {children}
        </div>
    );
};

export default Layout;
